import { Box, Center, Modal, ModalOverlay, VisuallyHidden, keyframes, useDisclosure } from '@chakra-ui/react';

// There is also a vanilla CSS version of this used in:
// typescript/frontend/uni/root/src/enroly-root-config.ts
// typescript/frontend/uni/root/src/index.ejs
// don't forget to update this with any changes made here

interface SpinnerModalProps {
  show: boolean;
  id?: string;
  size?: string;
  inner?: string;
  border?: string;
  duration?: string;
}

const spinKeyframes = keyframes`
0% { transform: rotate(0deg); }
30% { transform: rotate(90deg); }
45% { transform: rotate(180deg); }
65% { transform: rotate(270deg); }
100% { transform: rotate(360deg); }
`;

const SpinnerModal = (props: SpinnerModalProps) => {
  const { show, id = 'enroly', size = '96px', inner = '0.5em', border = '0.125em', duration = '1.25s' } = props;

  const { onClose } = useDisclosure();

  const pseudoCommon = {
    content: '""',
    display: 'block',
    height: inner,
    width: inner,
    position: 'absolute',
    borderRadius: 'full',
    borderStyle: 'solid',
    borderWidth: border
  };

  return (
    <>
      {show && (
        <Modal id={`${id}-loading`} onClose={onClose} isOpen={!!show} aria-busy={!!show} useInert={false}>
          <ModalOverlay bgColor="whiteAlpha.300" zIndex="overlay" />

          <Center width="100vw" height="100vh" position="fixed" left="0" top="0" zIndex="overlay">
            <Box
              bgColor="utility.900"
              borderRadius="full"
              color="white"
              display="inline-flex"
              fontSize={size}
              height="1em"
              width="1em"
              position="relative"
              alignItems="center"
              justifyContent="center"
              _before={{
                ...pseudoCommon,
                borderColor: 'whiteAlpha.200'
              }}
              _after={{
                ...pseudoCommon,
                borderColor: 'transparent',
                borderTopColor: 'yellow.500',
                animation: `2.5s ${spinKeyframes} linear infinite`,

                '@media (prefers-reduced-motion: no-preference)': {
                  animation: `${duration} ${spinKeyframes} linear infinite`
                }
              }}
            >
              <VisuallyHidden>Loading...</VisuallyHidden>
            </Box>
          </Center>
        </Modal>
      )}
    </>
  );
};

export default SpinnerModal;
